export default __webpack_public_path__ + "static/media/customer-journey-mapping.5bf541b2.svg";